<template>

  <div class="words-left-bar mdl-card mdl-shadow--2dp">
    <div class="mdl-card__title mdl-color--primary">
      <button v-if="false" class="mdl-button mdl-js-button mdl-button--fab mdl-button--raised mdl-button--accent expand"
              @click="toggleQueryExpand">
        <i class="material-icons" v-if="queryExpand">expand_less</i>
        <i class="material-icons" v-if="!queryExpand">expand_more</i>
      </button>
      <h2 class="mdl-card__title-text">{{ i18n().title }}</h2>

      <div class="query-controls">
        <button class="mdl-button mdl-js-button mdl-button--fab mdl-button--raised mdl-button--accent"
                @click="$emit('save')"><i class="material-icons">save</i></button>
        <button class="mdl-button mdl-js-button mdl-button--fab mdl-button--raised mdl-button--accent"
                @click="$emit('load')"><i class="material-icons">file_upload</i></button>
      </div>

    </div>
    <div class="mdl-card__supporting-text query-panel" v-show="queryExpand">

      <div>
        <WordsQuery :columns="wordsColumnNames" :categories="categories"
                    :query="query" @update:query="handleQueryUpdate"></WordsQuery>
      </div>

      <div>
        <Checkbox :checked="enableFilter" @update:checked="handleEnableFilterUpdate" :label="i18n().filterResults"></Checkbox>
      </div>

    </div>

  </div>

</template>

<script>

  import FilterExpression from "../query/FilterExpression"
  import SimpleFilterExpression from "../query/SimpleFilterExpression"
  import WordsQuery from "./WordsQuery.vue"
  import Checkbox from "../utils/Checkbox.vue"
  import config from "../../config"
  import i18n from "i18n"

  export default {
    name: "words-left-bar",
    props: {
      query: {
        type: Object
      },
      filter: {
        type: Object
      },
      appliedFilter: {
        type: Object
      },
      inputColumnNames: {
        type: Array
      },
      calculatedColumnNames: {
        type: Array
      },
      categories: {
        type: Array
      },
      enableFilter: {
        type: Boolean
      }
    },
    components: {
      Checkbox,
      FilterExpression,
      SimpleFilterExpression,
      WordsQuery
    },
    data() {
      return {
        queryExpand : true,
        filterExpand : true
      }
    },
    computed: {
      wordsColumnNames() {
        return this.inputColumnNames.filter(columnName => {
          if(config.logic.categoryColumns.indexOf(columnName) != -1) return false
          return true
        })
      }
    },
    methods: {
      i18n() {
        return i18n().ads.query
      },
      toggleQueryExpand() {
        this.queryExpand = !this.queryExpand
      },
      toggleFilterExpand() {
        this.filterExpand = !this.filterExpand
      },
      handleQueryUpdate(q) {
        this.$emit("update:query", q)
      },
      handleFilterUpdate(f) {
        this.$emit("update:filter", f)
      },
      handleEnableFilterUpdate(v) {
        this.$emit("update:enableFilter", v)
      }
    }
  }

</script>

<style scoped>

  .words-left-bar {
    position: absolute;
    left: 0em;
    top: 0em;
    bottom: 1em;
    width: 14em;
    height: auto;
  }
  .words-left-bar .mdl-card__title {
    flex-shrink: 0;
  }
  .words-left-bar .query-panel {
    flex-shrink: 0;
  }
  .words-left-bar .query-panel > div {
    margin-right: 1em;
  }

  .filter-holder {
    width: auto;
    overflow-y: auto;
    padding: 0;
  }

  .filter-controls > button {
    width: 28px;
    max-width: 28px;
    min-width: 28px;
    height: 28px;
    margin-left: 4px;
  }
  .filter-controls > button:nth-child(1) {
    margin-left: 12px;
  }
  .filter-controls > button > i {
    font-size: 20px;
  }

  .query-controls > button {
    width: 28px;
    max-width: 28px;
    min-width: 28px;
    height: 28px;
    margin-left: 4px;
  }
  .query-controls > button:nth-child(1) {
    margin-left: 12px;
  }
  .query-controls > button > i {
    font-size: 20px;
  }

  .mdl-button.expand {
    width: 28px;
    max-width: 28px;
    min-width: 28px;
    height: 28px;
    margin-left: -10px;
    margin-right: 8px;
  }
  .mdl-button.expand > i {
    font-size: 20px;
  }

  .words-left-bar {
    overflow-y: auto;
  }

</style>



// WEBPACK FOOTER //
// WordsLeftBar.vue?1f1eab06